import { PreloadingStrategy, Route } from '@angular/router';

import { Observable, of } from 'rxjs';

export class CustomPreloader implements PreloadingStrategy {

  /**
   * Preloading functionality
   * @param {Route} route
   * @param {Function} load
   * @return {Observable<any>}
   */
  public preload(route: Route, load: Function): Observable<any> {
    return route.data && route.data.preload ? load() : of(null);
  }
}